export const projects = [
  
  {
    title: "Multilingual RAG Student Support Chatbot",
    description: "Built Retrieval-Augmented Generation system using embedding models and vector databases for contextual institutional responses. Supports multiple languages and provides accurate, context-aware answers to student queries.",
    tech: ["Python", "RAG", "Vector DB", "LangChain"],
    achievements: ["87% retrieval accuracy", "Modular design", "Unit tested", "Multilingual support"],
    githubUrl:["https://github.com/Suhen02/chabot-assist"]
  },
  {
    title: "AI Interview Feedback System",
    description: "Modular Python pipeline for audio, pose, and text processing with real-time feedback generation. Analyzes candidate responses during mock interviews and provides instant feedback on communication skills, body language, and content quality.",
    tech: ["MediaPipe", "VADER", "Deep Learning", "Python"],
    achievements: ["Real-time feedback", "Optimized performance", "Scoring dashboards", "Multi-modal analysis"],
    githubUrl:["https://github.com/Suhen02/interviewAnalyze"]
  },
  {
    title: "Next Word Prediction (LSTM)",
    description: "Deep LSTM-based prediction model with comprehensive NLP preprocessing pipeline. Trained on large text corpora to predict next words in sentences, useful for text completion and language modeling tasks.",
    tech: ["LSTM", "NLP", "Deep Learning", "Python"],
    achievements: ["94% training accuracy", "Full preprocessing", "Interactive inference", "Scalable architecture"],
    githubUrl:["https://github.com/Suhen02/next-word-prediction-lstm"]
  },
  {
    title: "Resume Parsing & Examination System",
    description: "Hybrid NLP + LLM system for parsing resumes into structured JSON without hallucination. Uses rule-based parsing, LLM extraction, and examiner arbitration for reliable, schema-compliant outputs.",
    tech: ["Python", "Flask", "NLP", "LLM", "Mistral-7B", "JSON Schema"],
    achievements: ["No hallucination", "Production-grade", "Hybrid architecture", "Flask API"],
    githubUrl:["https://github.com/Suhen02/resume_parser"]
  },
  {
    title: "Movie Review Analysis (Streamlit Integrated)",
    description: "End-to-end NLP pipeline for sentiment analysis of movie reviews. Features automated Kaggle dataset download, text preprocessing, TF-IDF vectorization, Logistic Regression classification, and interactive Streamlit visualization.",
    tech: ["Python", "Streamlit", "scikit-learn", "NLP", "TF-IDF", "Logistic Regression"],
    achievements: ["87% accuracy", "End-to-end pipeline", "Interactive UI", "Kaggle integration"],
    githubUrl:["https://github.com/Suhen02/movie_review_analysis"]
  },
  {
    title: "Image Upscaling Application",
    description: "Advanced image enhancement application using BM3D denoising, ESRGAN super-resolution, and FPGAN face restoration. Processes images in packs for efficient high-quality upscaling and detail preservation.",
    tech: ["Python", "BM3D", "ESRGAN", "FPGAN", "GAN", "Image Processing"],
    achievements: ["High-quality denoising", "Realistic textures", "Face preservation", "Pack-based processing"],
    githubUrl:["https://github.com/Suhen02/upscale_image"]
  }
  
];

export const skills = {
  "Programming & CS": [
    "Python",
    "Data Structures",
    "Algorithms",
    "OOP",
    "Operating Systems",
    "Database Design"
  ],

  "Software Engineering": [
    "SDLC",
    "Git",
    "Version Control",
    "Unit Testing",
    "Integration Testing",
    "Code Reviews",
    "Problem Solving"
  ],

  "Backend & Databases": [
    "Flask",
    "Django",
    "FastAPI",
    "REST APIs",
    "PostgreSQL",
    "SQLite",
    "Docker"
  ],

  "AI & ML": [
    "Machine Learning",
    "Deep Learning",
    "CNN",
    "LSTM",
    "Transformers",
    "NLP",
    "RAG",
    "Feature Engineering",
    "Model Evaluation",
    "Supervised Learning",
    "Unsupervised Learning"
  ],

  "LLM & AI Tooling": [
    "LangChain",
    "LangSmith",
    "LlamaIndex",
    "Prompt Engineering",
    "Embeddings",
    "Vector Databases",
    "Retrieval Pipelines",
    "Fine-Tuning"
  ],

  "Libraries & Tools": [
    "TensorFlow",
    "Keras",
    "scikit-learn",
    "NLTK",
    "spaCy",
    "MediaPipe",
    "OpenCV",
    "Google Colab",
    "Jupyter Notebook",
    "FFmpeg"
  ]
};
